import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import ThemeProvider from "./theme";
import { StyledChart } from "./components/chart";
import ScrollToTop from "./components/scroll-to-top";
import Compose from "./utils/compose";
import { ProvideGlobalState } from "./contexts/global-context";
import { Toaster } from "react-hot-toast";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Google_Login_Client_ApiKey } from "./utils/constant";
import { DashboardRouter } from "./routes";
import { HashRouter } from "react-router-dom";
// ----------------------------------------------------------------------

export default function App() {
  return (
    <Compose components={[ProvideGlobalState]}>
      <GoogleOAuthProvider clientId={Google_Login_Client_ApiKey}>
        <HelmetProvider>
          <BrowserRouter >
            <Toaster
              position="top-right"
              reverseOrder={false}
              gutter={8}
              containerClassName=""
              containerStyle={{}}
              toastOptions={{
                className: "",
                duration: 5000,
                style: {
                  height: 85,
                  marginTop: 60,
                  background: "#363636",
                  color: "#fff",
                },
              }}
            />
            <ThemeProvider>
              <ScrollToTop />
              <StyledChart />
              <DashboardRouter />
            </ThemeProvider>
          </BrowserRouter >
        </HelmetProvider>
      </GoogleOAuthProvider>
    </Compose>
  );
}
